import React from 'react'
const { useLocation } = require("react-router-dom/cjs/react-router-dom.min");

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}


export default useQuery